import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import Hoc from "../../component/HOC";

const Help = () => {
  return (
    <Hoc activeMenu="Help">
      <div style={{ color: "#e8eeef", maxWidth: 640 }}>
        <h1 style={{ color: "#fff", marginBottom: 12 }}>Help</h1>
        <p style={{ color: "#b7c2c3", lineHeight: 1.55 }}>
          Step-by-step configuration for Program &amp; Subscriptions, Free Plan,
          courses, emails, Order Labs, and other Admin features is in the User
          Guide.
        </p>
        <Button
          component={Link}
          to="/user-guide"
          variant="contained"
          sx={{
            mt: 2,
            background: "#FEBD36",
            color: "#1a1a14",
            fontWeight: 700,
            "&:hover": { background: "#E5A82B" },
          }}
        >
          Open User Guide
        </Button>
      </div>
    </Hoc>
  );
};

export default Help;
